import { useAuth } from '../../../contexts/AuthContext';
import { securityApi } from '../services/securityApi';
import type { IntelSource } from '../types/security';
import { usePollingResource } from './usePollingResource';

const DEFAULT_INTERVAL_MS = 60_000;

export function useIntelSources(intervalMs: number = DEFAULT_INTERVAL_MS) {
  const { authFetch } = useAuth();
  return usePollingResource<IntelSource[]>({
    fetcher: () => securityApi.listIntelSources(authFetch),
    intervalMs,
  });
}
